import React, { useState, useEffect } from 'react';
import UpdateService from '../../../../services/admin/updates/updateService';
import GetDataDetail from '../../../../services/loaderService';
import { BiCheck } from 'react-icons/bi';
import config from '../../../../config';

const UpdateDirection = ({ id, fields }) => {
const [datas, setDatas] = useState([]);
const domain = config.api_domain.domain;
const url = `${domain}/direction`;

useEffect(() => {
    GetDataDetail(setDatas, url, id);
}, [setDatas, url, id]);

const [formData, setFormData] = useState({});

useEffect(() => {
    if (datas.length > 0) {
        setFormData({
            direction_brand: datas[0].direction_brand || "",
            direction_type: datas[0].direction_type || "",
            direction_ref: datas[0].direction_ref || "",
        });
    }
}, [datas]);

const [showForm, setShowForm] = useState(false);
const [showUpdatedText, setShowUpdatedText] = useState(true);

const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
};

const handleSubmit = (e) => {
    e.preventDefault();

    UpdateService('updateDirection', id, formData)
        .then(() => {
            setShowForm(false);
            setShowUpdatedText(true);
        })
        .catch((error) => {
            console.log(error);
        });
};

const handleOpenForm = () => {
    setShowForm(true);
    setShowUpdatedText(false);
};

return (
    <div>
        {showForm ? (
            <>
                <div>
                    <label className='modal-lavel' hidden={fields}>
                        Marca
                        <input
                            type="text"
                            className='form-control'
                            name="direction_brand"
                            value={formData.direction_brand}
                            onChange={handleChange}
                        />
                    <br /><br />
                    </label>
                    
                    <label className='modal-lavel' >
                        Tipo
                        <input
                            type="text"
                            className='form-control'
                            name="direction_type"
                            value={formData.direction_type}
                            onChange={handleChange}
                        />
                    <br /><br />
                    </label>
                    
                    <label className='modal-lavel' hidden={fields}>
                        Referencia
                        <input
                            type="text"
                            className='form-control'
                            name="direction_ref"
                            value={formData.direction_ref}
                            onChange={handleChange}
                        />
                    <br /><br />
                    </label>
                    <br /><br />
                    <button onClick={handleSubmit}>Actualizar Direccíon</button>
                </div>
            </>
        ) : null}

        {showUpdatedText ? (
            <>
                <p>Dirección actualizada <BiCheck style={{ fontSize: '30px', color: 'green' }} /></p>
                <button onClick={handleOpenForm}>Editar Dirección</button>
            </>
        ) : null}
    </div>
);
};

export default UpdateDirection;